import {FormikHandlers} from 'formik'
import {FC} from 'react'
import {Form} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {OptionType, TeamData} from '../../model/PersonnelModel'

interface Iprops {
  values: string | undefined | number
  errors?: any
  options?: OptionType[]
  optionsTeam?: TeamData[]
  name: string
  title?: string
  type: string
  required?: boolean
  disabled?: boolean
  as?: React.ElementType
  handleChange: FormikHandlers['handleChange']
  className?: string;
  [key: string]: any
}
const TextFieldCustom: FC<Iprops> = (props) => {
  const {
    values,
    handleChange,
    errors,
    name,
    options,
    title,
    optionsTeam,
    type,
    required,
    disabled,
    as,
    className,
    ...rest
  } = props

  return (
    <Form.Group controlId='validationFormik'>
      {title && (
        <Form.Label>
          {title}
          {required && <span className='text-danger'> * </span>}
        </Form.Label>
      )}
      {type === 'select' ? (
        <Form.Select
          name={name}
          value={values}
          onChange={handleChange}
          disabled={disabled}
          isInvalid={!!errors}
          size='sm'
        >
          <option hidden></option>
          {options && options?.map((opt: OptionType) => (
            <option key={opt.id} value={opt.value}>
              {opt.title}
            </option>
          ))}
          {optionsTeam && optionsTeam?.map((opt: TeamData) => (
            <option key={opt.id} value={opt.id}>
              {opt.name}
            </option>
          ))}
        </Form.Select>
      ) : (
        <Form.Control
          disabled={disabled}
          type={type}
          name={name}
          value={values}
          onChange={handleChange}
          isInvalid={!!errors}
          size='sm'
          as={as}
          className={className}
          {...rest}
        />
      )}

      <Form.Control.Feedback type='invalid'>{errors}</Form.Control.Feedback>
    </Form.Group>
  )
}
export {TextFieldCustom}
